/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */

/**
 * Enum representing different time categories for notifications.
 */
export enum TimeStamp {
  TODAY = 'Today',
  YESTERDAY = 'Yesterday',
  OLDER = 'Older'
};
